const FETCH_NETWORK_ERROR_MESSAGES = new Set([
  "network error", // Chrome
  "NetworkError when attempting to fetch resource.", // Firefox
  "The Internet connection appears to be offline.", // Safari 16
  "Network request failed", // cross-fetch
  "fetch failed", // Undici (Node.js)
  "terminated", // Undici (Node.js)
]);

/**
 * Checks if the error is a network error.
 * Based on: https://github.com/sindresorhus/is-network-error/blob/main/index.js
 */
const isNetworkError = (error: unknown) => {
  if (!error || typeof error !== "object") return false;

  const message =
    "message" in error && typeof error.message === "string"
      ? error.message.toLowerCase()
      : undefined;
  const stack =
    "stack" in error && typeof error.stack === "string"
      ? error.stack
      : undefined;

  // Safari 17+ has generic message but no stack for network errors
  if (message === "load failed") {
    return stack === undefined;
  }

  // Chrome: "Failed to fetch" or with hostname: "Failed to fetch (example.com)"
  if (
    message === "failed to fetch" ||
    (message?.startsWith("failed to fetch (") && message.endsWith(")"))
  ) {
    return true;
  }

  return message ? FETCH_NETWORK_ERROR_MESSAGES.has(message) : false;
};

export default isNetworkError;
